module.exports = __webpack_public_path__ + "img/1532831890.7719e288.jpg";